module.exports = __webpack_public_path__ + "img/shipo-menu-performance.7669db24.svg";